import { CF, Card } from "../../../_common/layout";
import { Checkbox } from "../../../_common/forms/components/Checkbox/Checkbox";
import { h } from "preact";
import { marked } from "marked";
import { t } from "../../../_i18n";
import { useEffect, useState } from "preact/hooks";

export default function Terms({ data, acceptTerms }) {
    /** States **/
    const [checked, setChecked] = useState(false);
    const [html, setHtml] = useState("");

    /** Lifecycles **/
    useEffect(() => {
        if (data?.content) {
            setHtml(marked(data.content));
        }
    }, [data]);

    /** Methods **/
    const handleSubmit = () => {
        acceptTerms();
    };

    /** Render **/
    return (
        <CF className="max-width">
            <h1 className="hero">{t("Certificados PUE")}</h1>
            <Card smOnly={false} class="m-x2-top">
                <span className="font-18">
                    {t("Para empezar a utilizar los Certificados PUE de ILERNA, lee y acepta la Política de Privacidad.")}
                </span>
                <Card className="m-top background-info font-18 p-all">
                    <div dangerouslySetInnerHTML={{ __html: html }} />
                </Card>
                <div className="m-top-x2 d-flex m-bottom font-18">
                    <Checkbox
                        onChange={(e) => setChecked(e)}
                        value={checked}
                        label={
                            <span>
                                {t("He leído y acepto la Política de Privacidad")}.
                            </span>
                        }
                    />
                </div>
                <button
                    className="btn btn-primary m-top full-width sm-no-full-width"
                    disabled={!checked}
                    onClick={handleSubmit}
                >
                    {t("Aceptar y continuar")}
                </button>
            </Card>
        </CF>
    );
}
